module.exports = __webpack_public_path__ + "static/img/VN.c3be4f7e.svg";